export var SiteURL;
(function (SiteURL) {
    SiteURL["CONVERT_PS_TO_PDF"] = "convert-ps-to-pdf";
    SiteURL["CONVERT_PNG_TO_PDF"] = "convert-png-to-pdf";
    SiteURL["CONVERT_TIFF_TO_PDF"] = "convert-tiff-to-pdf";
    SiteURL["SPLIT_PDF"] = "split-pdf";
    SiteURL["CONVERT_JPG_TO_PDF"] = "convert-jpg-to-pdf";
    SiteURL["CONVERT_PDF_TO_WORD"] = "convert-pdf-to-word";
    SiteURL["CONVERT_WORD_TO_PDF"] = "convert-word-to-pdf";
    SiteURL["CONVERT_POWERPOINT_TO_PDF"] = "convert-powerpoint-to-pdf";
    SiteURL["CONVERT_PDF_TO_IMAGE"] = "convert-pdf-to-image";
    SiteURL["CONVERT_PDF_TO_PS"] = "convert-pdf-to-ps";
    SiteURL["CONVERT_PDF_TO_PNG"] = "convert-pdf-to-png";
    SiteURL["CONVERT_PDF_TO_JPG"] = "convert-pdf-to-jpg";
    SiteURL["CONVERT_IMAGE_TO_PDF"] = "convert-image-to-pdf";
    SiteURL["MERGE_PDF"] = "merge-pdf";
    SiteURL["COMBINE_PDF"] = "combine-pdf";
    SiteURL["PDF_COMBINER"] = "pdf-combiner";
    SiteURL["PDF_MERGER"] = "pdf-merger";
    SiteURL["MERGE_IMAGE_TO_PDF"] = "merge-image-to-pdf";
    SiteURL["CONVERT_JPG_TO_PNG"] = "convert-jpg-to-png";
    SiteURL["CONVERT_PNG_TO_JPG"] = "convert-png-to-jpg";
    SiteURL["CONVERT_JPG_TO_WEBP"] = "convert-jpg-to-webp";
    SiteURL["CONVERT_WEBP_TO_JPG"] = "convert-webp-to-jpg";
    SiteURL["CONVERT_JPG_TO_TIFF"] = "convert-jpg-to-tiff";
    SiteURL["CONVERT_TIFF_TO_JPG"] = "convert-tiff-to-jpg";
    SiteURL["CONVERT_PNG_TO_WEBP"] = "convert-png-to-webp";
    SiteURL["CONVERT_WEBP_TO_PNG"] = "convert-webp-to-png";
    SiteURL["CONVERT_PNG_TO_TIFF"] = "convert-png-to-tiff";
    SiteURL["CONVERT_TIFF_TO_PNG"] = "convert-tiff-to-png";
    SiteURL["MEME_GENERATOR"] = "meme-generator";
    SiteURL["EDIT_IMAGE"] = "edit-image";
    SiteURL["RESIZE_IMAGE"] = "resize-image";
    SiteURL["IMAGE_RESIZER"] = "image-resizer";
    SiteURL["RESIZE_JPG"] = "resize-jpg";
    SiteURL["RESIZE_PNG"] = "resize-png";
    SiteURL["RESIZE_WEBP"] = "resize-webp";
    SiteURL["RESIZE_TIFF"] = "resize-tiff";
    SiteURL["CROP_IMAGE"] = "crop-image";
    SiteURL["CROP_JPG"] = "crop-jpg";
    SiteURL["CROP_PNG"] = "crop-png";
    SiteURL["CROP_WEBP"] = "crop-webp";
    SiteURL["CROP_TIFF"] = "crop-tiff";
    SiteURL["COMPRESS_IMAGE"] = "compress-image";
    SiteURL["IMAGE_COMPRESSOR"] = "image-compressor";
    SiteURL["COMPRESS_JPG"] = "compress-jpg";
    SiteURL["COMPRESS_JPEG"] = "compress-jpeg";
    SiteURL["COMPRESS_GIF"] = "compress-gif";
    SiteURL["COMPRESS_PNG"] = "compress-png";
    SiteURL["COMPRESS_WEBP"] = "compress-webp";
    SiteURL["COMPRESS_TIFF"] = "compress-tiff";
    SiteURL["COMPRESS_HEIC"] = "compress-heic";
    SiteURL["COMPRESS_JPG_IMAGE_ONLINE"] = "compress-jpg-image-online";
    SiteURL["COMPRESS_PDF"] = "compress-pdf";
    SiteURL["COMPRESS_MP4"] = "compress-mp4";
    SiteURL["COMPRESS_MKV"] = "compress-mkv";
    SiteURL["COMPRESS_MOV"] = "compress-mov";
    SiteURL["COMPRESS_M4V"] = "compress-m4v";
    SiteURL["COMPRESS_MTS"] = "compress-mts";
    SiteURL["COMPRESS_MPG"] = "compress-mpg";
    SiteURL["COMPRESS_WEBM"] = "compress-webm";
    SiteURL["VIDEO_COMPRESSOR"] = "video-compressor";
    SiteURL["AUDIO_COMPRESSOR"] = "audio-compressor";
    SiteURL["COMPRESS_MP3"] = "compress-mp3";
    SiteURL["COMPRESS_WAV"] = "compress-wav";
    SiteURL["COMPRESS_M4R"] = "compress-m4r";
    SiteURL["VIDEO_CONVERTER"] = "video-converter";
    SiteURL["MP4_CONVERTER"] = "mp4-converter";
    SiteURL["CONVERT_VIDEO_TO_WEBM"] = "convert-video-to-webm";
    SiteURL["CONVERT_VIDEO_TO_MP4"] = "convert-video-to-mp4";
    SiteURL["CONVERT_MKV_TO_MP4"] = "convert-mkv-to-mp4";
    SiteURL["CONVERT_AVI_TO_MP4"] = "convert-avi-to-mp4";
    SiteURL["CONVERT_MOV_TO_MP4"] = "convert-mov-to-mp4";
    SiteURL["CONVERT_WEBM_TO_MP4"] = "convert-webm-to-mp4";
    SiteURL["CONVERT_FLV_TO_MP4"] = "convert-flv-to-mp4";
    SiteURL["CONVERT_M4V_TO_MP4"] = "convert-m4v-to-mp4";
    SiteURL["CONVERT_WMV_TO_MP4"] = "convert-wmv-to-mp4";
    SiteURL["CONVERT_MTS_TO_MP4"] = "convert-mts-to-mp4";
    SiteURL["CONVERT_MPG_TO_MP4"] = "convert-mpg-to-mp4";
    SiteURL["CONVERT_MKV_TO_WEBM"] = "convert-mkv-to-webm";
    SiteURL["CONVERT_AVI_TO_WEBM"] = "convert-avi-to-webm";
    SiteURL["CONVERT_WEBM_TO_WEBM"] = "convert-webm-to-webm";
    SiteURL["CONVERT_FLV_TO_WEBM"] = "convert-flv-to-webm";
    SiteURL["CONVERT_M4V_TO_WEBM"] = "convert-m4v-to-webm";
    SiteURL["CONVERT_WMV_TO_WEBM"] = "convert-wmv-to-webm";
    SiteURL["CONVERT_MTS_TO_WEBM"] = "convert-mts-to-webm";
    SiteURL["CONVERT_MPG_TO_WEBM"] = "convert-mpg-to-webm";
    SiteURL["CONVERT_MOV_TO_WEBM"] = "convert-mov-to-webm";
    SiteURL["CONVERT_GIF_TO_VIDEO"] = "convert-gif-to-video";
    SiteURL["CONVERT_GIF_TO_MP4"] = "convert-gif-to-mp4";
    SiteURL["CONVERT_GIF_TO_WEBM"] = "convert-gif-to-webm";
    SiteURL["CONVERT_VIDEO_TO_GIF"] = "convert-video-to-gif";
    SiteURL["CONVERT_MP4_TO_GIF"] = "convert-mp4-to-gif";
    SiteURL["CONVERT_WEBM_TO_GIF"] = "convert-webm-to-gif";
    SiteURL["CONVERT_MOV_TO_GIF"] = "convert-mov-to-gif";
    SiteURL["CONVERT_VIDEO_TO_MP3"] = "convert-video-to-mp3";
    SiteURL["AUDIO_CONVERTER"] = "audio-converter";
    SiteURL["CONVERT_MP4_TO_MP3"] = "convert-mp4-to-mp3";
    SiteURL["CONVERT_PDF_TO_EPUB"] = "convert-pdf-to-epub";
    SiteURL["CONVERT_PDF_TO_MOBI"] = "convert-pdf-to-mobi";
    SiteURL["CONVERT_EPUB_TO_MOBI"] = "convert-epub-to-mobi";
    SiteURL["CONVERT_MOBI_TO_EPUB"] = "convert-mobi-to-epub";
    SiteURL["URL_ENCODER"] = "url-encoder";
    SiteURL["URL_DECODER"] = "url-decoder";
    SiteURL["WORD_COUNT"] = "word-count";
    SiteURL["BASE64_ENCODE"] = "base64-encode";
    SiteURL["BASE64_DECODE"] = "base64-decode";
    SiteURL["CONVERT_OGG_TO_MP3"] = "convert-ogg-to-mp3";
    SiteURL["CONVERT_M4A_TO_MP3"] = "convert-m4a-to-mp3";
    SiteURL["CONVERT_M4A_TO_WAV"] = "convert-m4a-to-wav";
    SiteURL["CONVERT_WAV_TO_MP3"] = "convert-wav-to-mp3";
    SiteURL["CONVERT_MP3_TO_WAV"] = "convert-mp3-to-wav";
    SiteURL["CONVERT_FLAC_TO_MP3"] = "convert-flac-to-mp3";
    SiteURL["CONVERT_WMA_TO_MP3"] = "convert-wma-to-mp3";
    SiteURL["CONVERT_AIFF_TO_MP3"] = "convert-aiff-to-mp3";
    SiteURL["CONVERT_AAC_TO_MP3"] = "convert-aac-to-mp3";
    SiteURL["CONVERT_FLAC_TO_WAV"] = "convert-flac-to-wav";
    SiteURL["CONVERT_MP3_TO_M4A"] = "convert-mp3-to-m4a";
    SiteURL["CONVERT_OPUS_TO_MP3"] = "convert-opus-to-mp3";
    SiteURL["CONVERT_MP3_TO_M4R"] = "convert-mp3-to-m4r";
    SiteURL["CONVERT_MP4_TO_WAV"] = "convert-mp4-to-wav";
    SiteURL["CONVERT_WEBM_TO_MP3"] = "convert-webm-to-mp3";
    SiteURL["JPG_TO_PNG"] = "jpg-to-png";
    SiteURL["PNG_TO_JPG"] = "png-to-jpg";
    SiteURL["JPG_TO_WEBP"] = "jpg-to-webp";
    SiteURL["WEBP_TO_JPG"] = "webp-to-jpg";
    SiteURL["JPG_TO_TIFF"] = "jpg-to-tiff";
    SiteURL["TIFF_TO_JPG"] = "tiff-to-jpg";
    SiteURL["PNG_TO_WEBP"] = "png-to-webp";
    SiteURL["WEBP_TO_PNG"] = "webp-to-png";
    SiteURL["PNG_TO_TIFF"] = "png-to-tiff";
    SiteURL["TIFF_TO_PNG"] = "tiff-to-png";
    SiteURL["JPG_TO_HEIC"] = "jpg-to-heic";
    SiteURL["HEIC_TO_JPG"] = "heic-to-jpg";
    SiteURL["WEBP_TO_HEIC"] = "webp-to-heic";
    SiteURL["HEIC_TO_WEBP"] = "heic-to-webp";
    SiteURL["PNG_TO_HEIC"] = "png-to-heic";
    SiteURL["HEIC_TO_PNG"] = "heic-to-png";
    SiteURL["TIFF_TO_HEIC"] = "tiff-to-heic";
    SiteURL["HEIC_TO_TIFF"] = "heic-to-tiff";
    SiteURL["CR2_TO_JPG"] = "cr2-to-jpg";
    SiteURL["NEF_TO_JPG"] = "nef-to-jpg";
    SiteURL["VIDEO_CUTTER"] = "video-cutter";
    SiteURL["VIDEO_TRIMMER"] = "video-trimmer";
    SiteURL["AUDIO_TRIMMER"] = "audio-trimmer";
    SiteURL["AUDIO_CUTTER"] = "audio-cutter";
    SiteURL["MP3_CUTTER"] = "mp3-cutter";
    SiteURL["MP3_TRIMMER"] = "mp3-trimmer";
    SiteURL["RAR_TO_ZIP"] = "rar-to-zip";
    SiteURL["ZIP_TO_RAR"] = "zip-to-rar";
    SiteURL["TAR_TO_ZIP"] = "tar-to-zip";
    SiteURL["ZIP_TO_TAR"] = "zip-to-tar";
    SiteURL["7Z_TO_ZIP"] = "7z-to-zip";
    SiteURL["UNZIP_FILES"] = "unzip-files";
    SiteURL["UNZIP_TAR"] = "unzip-tar.gz.GZ";
    SiteURL["ZIP_EXTRACTOR"] = "zip-extractor";
    SiteURL["RAR_EXTRACTOR"] = "rar-extractor";
    SiteURL["RAR_FILES"] = "rar-files";
    SiteURL["7ZIP"] = "7zip";
})(SiteURL || (SiteURL = {}));
